<!--
  SupplierIntegrations -- the supplier rows on Account > Suppliers (was Integrations).

  Each supplier gets the same container the Stripe Connect card gets on
  Payments (an outer card + card text around the row card), so the page
  reads as one list in one visual language rather than a grid of logo tiles.
-->
<template>
  <div data-testid="supplier-integrations-root">
    <v-card
      v-for="integration in integrations"
      :key="integration.id"
      class="tf-supplier-integration"
    >
      <v-card-text>
        <supplier-integration-card
          :supplierID="integration.id"
          :name="integration.name"
          :supplierKey="integration.supplier_key"
          :accountNumber="integration.account_number"
          :isConnected="integration.is_connected"
          @connect="openSupplierConnectionDialog"
          @edit="openEditSupplierConnectionDialog"
          @disconnect="openDisconnectConnectionDialog"
        />
      </v-card-text>
    </v-card>
    <connect-supplier-integration-dialog
      ref="connect-supplier-integration-dialog"
      @connection-verified="loadIntegrations"
    />
    <disconnect-integration-dialog
      ref="disconnect-supplier-integration-dialog"
      @disconnected="loadIntegrations"
    />
  </div>
</template>

<script>
import { describeError } from "@/utils/safeErrorLog";
import rules from "@/mixins/rules";
import { mapGetters } from "vuex";
import helpers from "@/mixins/helpers";
import SupplierIntegrationCard from "./SupplierIntegrationCard.vue";
import ConnectSupplierIntegrationDialog from "./ConnectSupplierIntegrationDialog.vue";
import DisconnectIntegrationDialog from "./DisconnectIntegrationDialog.vue";

export default {
  components: {
    SupplierIntegrationCard,
    ConnectSupplierIntegrationDialog,
    DisconnectIntegrationDialog,
  },
  data() {
    return {
      integrations: [],
    };
  },

  watch: {},

  computed: {},

  mixins: [rules, helpers],

  async mounted() {
    this.loadIntegrations();
  },

  methods: {
    async loadIntegrations() {
      this.integrations = [];
      let result;
      try {
        result = await this.$axios.get(
          `/supplier_integrations/getIntegrationList/`
        );
        this.integrations = result.data;
      } catch (err) {
        console.log(describeError(err));
        this.$store.dispatch("raiseError", err);
      } finally {
      }
    },

    // The dialogs ask for and name the credential per supplier (S&S takes
    // account number + API key, SanMar a login + password), so they get the
    // supplier's name and key along with its id.
    supplierContext(supplierID) {
      const integration =
        this.integrations.find((i) => i.id === supplierID) || {};
      return {
        name: integration.name,
        supplierKey: integration.supplier_key,
      };
    },
    openSupplierConnectionDialog(supplierID) {
      this.$refs["connect-supplier-integration-dialog"].open(
        supplierID,
        false,
        this.supplierContext(supplierID)
      );
    },
    openEditSupplierConnectionDialog(supplierID) {
      this.$refs["connect-supplier-integration-dialog"].open(
        supplierID,
        true,
        this.supplierContext(supplierID)
      );
    },
    openDisconnectConnectionDialog(supplierID) {
      this.$refs["disconnect-supplier-integration-dialog"].open(
        supplierID,
        this.supplierContext(supplierID)
      );
    },
  },
};
</script>

<style scoped>
.tf-supplier-integration {
  margin-bottom: var(--tf-sp-4, 16px);
}
</style>

